<div class="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
    <div class="flex items-center justify-between px-5 py-4 border-b border-gray-100">
        <div class="flex items-center gap-2">
            <span class="h-9 w-9 rounded-xl bg-amber-50 flex items-center justify-center">
                <mat-icon class="!text-amber-500 !text-[20px] !h-5 !w-5">shopping_basket</mat-icon>
            </span>
            <h2 class="font-semibold text-gray-900">Basket</h2>
        </div>
        <span class="text-[11px] font-semibold px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600">{{ localCart.items.length }} item{{ localCart.items.length === 1 ? '' : 's' }}</span>
    </div>

    <div class="flex flex-col divide-y divide-gray-50 max-h-[46vh] overflow-y-auto">
        @for (cartItem of localCart.items; track $index) {
        <div class="flex items-start gap-3 px-5 py-3.5 group">
            <div class="flex-1 min-w-0">
                <div class="text-sm font-semibold text-gray-900 leading-snug">{{ cartItem.name }}</div>
                <div class="mt-1 flex items-center gap-2 text-xs text-gray-500">
                    <span class="font-semibold text-gray-700 px-2 py-0.5 rounded-full bg-gray-100">x {{ cartItem.quantity }}</span>
                    <span>£{{ cartItem.unitPrice }} each</span>
                </div>
            </div>
            <div class="text-right flex-shrink-0">
                <div class="text-sm font-bold text-gray-900">£{{ (cartItem.quantity * cartItem.unitPrice).toFixed(2) }}</div>
                <button (click)="onItemRemoval($index)" class="mt-1 text-[11px] font-semibold text-gray-400 hover:text-red-600 flex items-center gap-0.5 ml-auto transition-colors" matTooltip="Remove from basket">
                    <mat-icon class="!text-[14px] !h-[14px] !w-[14px]">delete</mat-icon> Remove
                </button>
            </div>
        </div>
        }
    </div>

    <div class="px-5 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between text-sm">
        <span class="text-gray-500 flex items-center gap-1.5">
            <mat-icon class="!text-[16px] !h-4 !w-4 !text-gray-400">scale</mat-icon> Total weight {{ onGetTotalWeight() }} kg
        </span>
        <span class="font-bold text-gray-900">Items total £{{ onGetOrderTotal() }}</span>
    </div>
</div>
